import { useI18n } from "@/i18n";

/* Détection du MOTEUR, pas du nom : Chromium et WebKit passent, Gecko (Firefox) avertit.
   Une fonction manquante au moteur vidéo (WebGL, encodage) avertit quel que soit le navigateur. */
export function browserEngine() {
  const ua = navigator.userAgent || "";
  if (/Gecko\/\d/.test(ua) && !/like Gecko/.test(ua)) return "gecko";
  if (/Chrome|Chromium|CriOS|Edg|OPR|SamsungBrowser/.test(ua)) return "chromium";
  if (/AppleWebKit/.test(ua)) return "webkit";
  return "other";
}

export function engineCapable() {
  try {
    const c = document.createElement("canvas");
    if (!(c.getContext("webgl2") || c.getContext("webgl"))) return false;
  } catch {
    return false;
  }
  return !!(window.VideoEncoder && window.VideoDecoder);
}

export function needsBrowserWarning() {
  const e = browserEngine();
  return e === "gecko" || e === "other" || !engineCapable();
}

const KEY = "bc_browser_warned";
export const browserWarningShown = () => {
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return true; }
};
export const markBrowserWarningShown = () => {
  try { sessionStorage.setItem(KEY, "1"); } catch {}
};

const TXT = {
  fr: {
    title: "Attention",
    body: "Attention, ton navigateur n'est pas optimisé pour BeatCut. Tu peux créer un projet, mais tu vas rencontrer des ralentissements. Passe sur Chrome ou Safari pour des performances optimales.",
    go: "Continuer quand même",
    ok: "Compris",
  },
  en: {
    title: "Heads up",
    body: "Your browser isn't optimised for BeatCut. You can create a project, but you will run into slowdowns. Switch to Chrome or Safari for the best performance.",
    go: "Continue anyway",
    ok: "Got it",
  },
};

export default function BrowserWarning({ onContinue }) {
  const { lang } = useI18n();
  const t = TXT[lang] || TXT.fr;
  const done = () => { markBrowserWarningShown(); onContinue?.(); };
  return (
    <div className="fixed inset-0 z-[9995] bg-black/80 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" role="dialog" aria-modal="true" data-testid="browser-warning">
      <div className="w-full max-w-md bg-card border border-border p-7 sm:p-8">
        <p className="font-osd text-xs tracking-[0.25em] text-primary mb-3">[ {t.title.toUpperCase()} ]</p>
        <p className="text-sm leading-relaxed text-foreground" data-testid="browser-warning-text">{t.body}</p>
        <div className="mt-7 grid grid-cols-2 gap-3">
          <button
            onClick={done}
            data-testid="browser-warning-understood"
            className="h-11 border border-border font-osd text-[11px] tracking-[0.08em] uppercase text-foreground hover:border-foreground transition-colors"
          >
            {t.ok}
          </button>
          <button
            onClick={done}
            data-testid="browser-warning-continue"
            className="h-11 rounded-full bg-primary text-white font-osd text-[11px] tracking-[0.08em] uppercase hover:opacity-90 transition-opacity"
          >
            {t.go}
          </button>
        </div>
      </div>
    </div>
  );
}
